import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
} from "antd"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import Upload, { RcFile } from "antd/lib/upload"
import styles from "../filing.module.css"
import axios from "axios"
import { PreviewImgOrPdf } from "../Preview"
import { AXIOS_IP, beforeUploadFile, customRequest } from "../fileUploadService"
import { selectCredentials } from "../../../app/applicationSlice"

export const DJDPAgainModal = (props: {
  visible: boolean
  token: string
  state: number
  id?: number
  filingDecoctionRecordId?: number
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => { 
  const credentials: any = useSelector(selectCredentials)
  
  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<any>([]) //上年
  const [fileWWList, setFileWWList] = useState<any>([]) //委外

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [detail, setDetail] = useState<any>()

  const [submitVisible, setSubmitVisible] = useState(false)

  const [isClient, setIsClient] = useState(true) //是否

  const [isFile, setIsFile] = useState(true) //显示那个文件

  //参考模板
  const templateData = {
    fileConfigId: "5",
    fileName: "参考模板",
    fileType: "application/pdf",
    filePath:
      "68e0cfd54adf77575a83a2b739bf5ddfa207356d866e9e74b8236c4b070475f8",
  }

  // 自定义上传实现
  const customRequestFn = (options: any, type: string) => {
    customRequest(options, AXIOS_IP, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      switch (type) {
        case "DJ":
          setFileList([...fileList, newurl])
          break
      }
      switch (type) {
        case "WW":
          setFileWWList([...fileWWList, newurl])
          break
      }
    })
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "DJ":
        setFileList(fileList?.filter((v: any, i: number) => i !== index))
        break
      case "WW":
        setFileWWList(fileWWList?.filter((v: any, i: number) => i !== index))
        break
    }
  }
  
  const getData = () => {
      axios({
        url: props.state == 1 ? `${AXIOS_IP}/filingDecoction/detail`
        : `${AXIOS_IP}/filingReviewDecoction/detail`,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": props.token,
        },
        withCredentials: false,
        method: "POST",
        data: { id: props.state == 1 ? props.filingDecoctionRecordId : props.id },
      }).then((res) => {
        const data = res.data.data
        setDetail(data)
        form.setFieldsValue({
          ...data,
          conditionReportUrl: [],
          clientDecoctionUrl: [],
        })
        setIsClient(data?.isClient === 1)
        if(props.state == 2) {
          setFileList(res.data.data?.conditionReport?.length 
            ? res.data.data?.conditionReport[res.data.data?.conditionReport?.length - 1]?.previousYearAssessmentReportFileUrl
            : []
          )
          setFileWWList(res.data.data?.clientDecoctionUrl || [])
        }
    })
    axios({
      url: `${AXIOS_IP}/filingDecoction/checkFilingFile`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: { id: props.filingDecoctionRecordId },
    }).then((res) => { 
      setIsFile(res.data.data || false)
    })
  }
  

  useEffect(() => {
    form.setFieldsValue({
      conditionReportUrl: fileList,
    })
  }, [fileList])

  useEffect(() => {
    form.setFieldsValue({
      clientDecoctionUrl: fileWWList,
    })
  }, [fileWWList])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setFileList([])
      setFileWWList([])
      setIsClient(true)
    } else {
      if(props.filingDecoctionRecordId) {
        getData()
      }
    }
  }, [props.visible, props.filingDecoctionRecordId])

  return (
    <>
      <Modal
        title="中药代煎代配再次备案"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setSubmitVisible(true)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="isClient"
                  label="是否为委托第三方代煎代配"
                  rules={[{ required: true }]}
                >
                  <Radio.Group onChange={(e) => setIsClient(e.target.value === 1)}>
                    <Radio value={1}>是</Radio>
                    <Radio value={0}>否</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {isClient ? <>
                <Col span={24}>
                  <Form.Item
                    name="clientOrgName"
                    label="委托方机构名称"
                    rules={[{ required: true }]}
                  >
                    <Input disabled={detail?.isClient === 1} allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="clientName"
                    label="委托方联系人姓名"
                    rules={[{ required: true }]}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="clientPhone"
                    label="委托方联系方式"
                    rules={[{ required: true }]}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                {isFile ? <Col span={24}>
                  <Form.Item
                    label="上年度情况报告"
                    name="conditionReportUrl"
                    rules={[{ required: true }]}
                  >
                    <Row align="middle">
                      <Upload
                        customRequest={(options) =>
                          customRequestFn(options, "DJ")
                        }
                        beforeUpload={(file) => beforeUploadFile(file, fileList, 1)}
                        showUploadList={false}
                        maxCount={1}
                        accept={".pdf"}
                      >
                        <Button icon={<PlusOutlined />}>上传</Button>
                      </Upload>
                      <span style={{ padding: "0 10px 0 15px" }}>
                        支持pdf等文件格式
                      </span>
                      {/* <a
                        style={{ textDecoration: "underline", paddingRight: 10 }}
                        onClick={() => setPreviewFile(templateData)}
                      >
                        参考模板
                      </a> */}
                      {fileList?.length > 0 &&
                        fileList?.map((v: any, index: number) => {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                paddingRight: 10,
                              }}
                            >
                              <span style={{ paddingRight: 10 }}>
                                {v.fileName}{" "}
                                <a
                                  style={{ paddingLeft: 10 }}
                                  onClick={() => setPreviewFile(v)}
                                >
                                  查看
                                </a>
                              </span>
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("DJ", index)
                                }}
                              />
                            </div>
                          )
                        })}
                    </Row>
                  </Form.Item>
                </Col> :
                <Col span={24}>
                  <Form.Item
                    label="委外代煎协议"
                    name="clientDecoctionUrl"
                    rules={[{ required: true }]}
                  >
                    <Row align="middle">
                      <Upload
                        customRequest={(options) =>
                          customRequestFn(options, "WW")
                        }
                        beforeUpload={(file) => beforeUploadFile(file, fileWWList)}
                        showUploadList={false}
                        maxCount={1}
                        accept={".pdf"}
                      >
                        <Button icon={<PlusOutlined />}>上传</Button>
                      </Upload>
                      <span style={{ padding: "0 10px 0 15px" }}>
                        支持pdf等文件格式
                      </span>
                      {/* <a
                        style={{ textDecoration: "underline", paddingRight: 10 }}
                        onClick={() => setPreviewFile(templateData)}
                      >
                        参考模板
                      </a> */}
                      {fileWWList?.length > 0 &&
                        fileWWList?.map((v: any, index: number) => {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                paddingRight: 10,
                              }}
                            >
                              <span style={{ paddingRight: 10 }}>
                                {v.fileName}{" "}
                                <a
                                  style={{ paddingLeft: 10 }}
                                  onClick={() => setPreviewFile(v)}
                                >
                                  查看
                                </a>
                              </span>
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("WW", index)
                                }}
                              />
                            </div>
                          )
                        })}
                    </Row>
                  </Form.Item>
                </Col>}
              </> : ''}
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={600}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const data = {
            ...form.getFieldsValue(),
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            previousYearAssessmentReportFileUrl: detail.clientDecoctionUrl,
            filingRecordId: props.filingDecoctionRecordId,
            filingReviewRecordId: props.id,
            memo: props.memo,
          }
          axios({
            url: `${AXIOS_IP}/filingReviewDecoction/restartFiling`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          })
            .then(() => {
              setSubmitVisible(false)
              notification.success({
                message: "操作成功",
              })
              props.onOk()
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 100 }}>
          提交后请耐心等待工作人员审核，如有任何疑问请拨打400-888888
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
